import styled from "styled-components";

export const OTPtime = styled.span`

color: ${(props) => props.theme.primaryColor.primary};
font-weight: 500;

`;